import { AddRightsStatusEnum } from "@entities/addRights/lib/constants";

export function getAddRightsStatusDisplay(status: AddRightsStatusEnum): {
  label: string;
  classNameKey: string;
} {
  switch (status) {
    case AddRightsStatusEnum.Active:
      return { label: "Active", classNameKey: "addRightsStatusActive" };
    case AddRightsStatusEnum.Expired:
      return { label: "Expired", classNameKey: "addRightsStatusExpired" };
    case AddRightsStatusEnum.ActionPending:
      return {
        label: "Action Pending",
        classNameKey: "addRightsStatusActionPending",
      };
    case AddRightsStatusEnum.Upcoming:
      return { label: "Upcoming", classNameKey: "addRightsStatusUpcoming" };
    case AddRightsStatusEnum.Cancelled:
      return { label: "Cancelled", classNameKey: "addRightsStatusCancelled" };
    case AddRightsStatusEnum.Withdrawn:
      return { label: "Withdrawn", classNameKey: "addRightsStatusWithdrawn" };
    default:
      return {
        label: status || "—",
        classNameKey: "addRightsStatusDefault",
      };
  }
}
